import React, {useState} from 'react';
import {RootState} from "../../../../../reducers";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {ConfigApi, DineInType, OrderType} from "../../../../services/Api/types";
import CartChangeOrderDetailsTypeOptionModal from "./CartChangeOrderDetailsTypeOptionModal";
import StoreUtils from "../../../../services/Store/StoreUtils";
import {anyMenuHasPickDate} from "../../utils";
import {getAvailabilities, getCategories, getItems, getMenus, getPromotions} from "../../../../services/Menu/reducer";
import {getParsedSessionOrderType} from "../../../../utils/order";
import {getCart} from "../../../../services/Cart/reducer";
import DisabledCartItemsModal from "../DisabledCartItemsModal/DisabledCartItemsModal";
import ItemHelper from "../../../../services/Menu/services/Item/ItemHelper";
import ItemViewHelper from "../../../../services/Menu/services/Item/ItemViewHelper";

interface OwnProps {
    setCurrentType: React.Dispatch<React.SetStateAction<"" | OrderType>>;
    currentType: "" | OrderType;
    time: string | undefined;
    setTime: React.Dispatch<React.SetStateAction<string | undefined>>;
    setDineInOption: React.Dispatch<React.SetStateAction<DineInType | undefined>> | undefined;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const getDefaultTypes = (config: ConfigApi | undefined, currentType: "" | OrderType) => {
    if (!config) return [];

    let types: OrderType[] = StoreUtils.getOrderTypes(config);

    if (currentType !== "") {
        types = [currentType, ...types.filter((type) => type !== currentType)];
    }

    return types;
}

const CartChangeOrderDetailsTypesModal = ({
                                              config,
                                              setCurrentType,
                                              currentType,
                                              time,
                                              setTime,
                                              cart,
                                              promotions,
                                              availabilities,
                                              items,
                                              categories,
                                              setDineInOption,
                                              menus
                                          }: Props) => {
    const [types] = useState(getDefaultTypes(config, currentType));
    const [lastOrderType, setLastOrderType] = useState<OrderType | "">(currentType);
    const [disabledCartItems, setDisabledCartItems] = useState<any[]>([]);
    const dineInOptions: DineInType[] = StoreUtils.getDineInTypes(config);

    if (types.length === 0) return <></>;

    const getPossibleDisabledItemsForType = (type: OrderType, isOpen: boolean) => {
        if (!isOpen) {
            return cart.items.map((cartItem: any) => ItemHelper.getItem(items, cartItem.item_id)).filter(Boolean);
        }

        const cartItems = cart.items.map((cartItem: any) => {

            const item = ItemHelper.getItem(items, cartItem.item_id);

            if (!item) return undefined;

            return {
                item,
                itemView: ItemViewHelper.parseItem(item, availabilities, promotions, time, undefined, cart, type)
            }
        }).filter(Boolean);

        return cartItems.filter(item => !ItemHelper.isItemAvailableForOrderType(item?.itemView, type, menus, categories))
            .map(item => item?.item).filter(Boolean);
    }

    const handleOnChange = (type: OrderType, isOpen: boolean, skipCheckingItems?: true) => {
        if (config && !StoreUtils.getOrderTypes(config).includes(type)) return;

        setLastOrderType(type);

        if (!skipCheckingItems) {
            const possibleDisabledItems = getPossibleDisabledItemsForType(type, isOpen);
            if (possibleDisabledItems.length > 0) {
                setDisabledCartItems(possibleDisabledItems);
                return;
            }
        }

        setCurrentType(type);

        if (type === OrderType.DINE_IN && setDineInOption) {
            if (dineInOptions.length > 1) return;

            setDineInOption(dineInOptions[0]);
        }

        if (time && !anyMenuHasPickDate(menus, getParsedSessionOrderType(type))) {
            setTime(undefined);
        }
    }

    const handleOnHideModal = () => {
        setDisabledCartItems([]);
    }

    const handleOnSubmitModal = () => {
        if (lastOrderType) handleOnChange(lastOrderType, true, true);
        handleOnHideModal();
    }

    return (
        <div className="change-order-details-types">
            {types.map((type) => (
                <CartChangeOrderDetailsTypeOptionModal key={type} type={type} checked={type === currentType}
                                                       onChange={handleOnChange} time={time}/>

            ))}
            {disabledCartItems.length > 0 && <DisabledCartItemsModal show={disabledCartItems.length > 0}
                                                                     items={disabledCartItems}
                                                                     type="ORDER_TYPE"
                                                                     orderType={lastOrderType}
                                                                     onSubmit={handleOnSubmitModal}
                                                                     onHide={handleOnHideModal}/>}
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    cart: getCart(state.cart),
    availabilities: getAvailabilities(state.menu),
    promotions: getPromotions(state.menu),
    items: getItems(state.menu),
    categories: getCategories(state.menu),
    menus: getMenus(state.menu),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartChangeOrderDetailsTypesModal));